

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface PurchaseDetailsParameter extends Parameter {
    SearchTerm: number;
    OrderBy: string;
  
}

export interface PurchaseDetails {
    rowId: Number;
    grnId: string;

    medicineId: string;

    batchNum: string;

    expiryDate: string;

    rackId: string;

    boxNo: string;

    unitsStrips: Number; 

    noOfStrips: Number; 

    pricePerStrip: Number;

    mrpPerStrip: Number;
    sellPerPrice: Number;
    freeStrip: Number; 

    discountPer: Number; 

    discountValue: Number;

    hsnCode: string;

    gstTotalPer: string;

    igstPer: Number; 

    cgstPer: Number;

    sgstPer: Number;

    gstTotalValue: Number;

    igstValue: Number;

    cgstValue: Number;

    sgstValue: Number;

    totalPrice: Number; 

    upcEanCode: string; 

    taxableAmount: Number;

    payableAmount: Number;
  
    tenantId: string;

    branchId: string;
    
    //new column
    noOfUnitQty:number;
    noOfStripsQty: number;
    noOfFreeUnitQty:number;
    noOfFreeStripQty:number;
    
    
    parameters?: PurchaseDetailsParameter[];
    links?: any;
}

export abstract class PurchaseDetailsData {
  
  abstract list(url: string): Observable<PurchaseDetails[]>;
  abstract create(url: string,data: PurchaseDetails): Observable<any>;
  abstract update(url: string,data: PurchaseDetails): Observable<any>;
  abstract delete(url: string): Observable<any>;
}
